/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import bouzayen from '../../images/mascotte2.jpg';
import mall from '../../images/infoPic.jpg';
import Footer from "../../Components/Footer";
import ScrollToTop from "../../Components/scrollpageUp";
import MenuItem from "../../Components/menuItem";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import "./style.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";

export default function Menu() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#000",
        dark: "#222",
        contrastText: "#FFCD00",
      },
    },
  });

  const [showMenu, setShowMenu] = useState(false);
  const [data, setData] = useState('');
  const [menuButtons, setMenuButtons] = useState([]); // State for menu buttons
  const [selectedCategory, setSelectedCategory] = useState('');

  const menuBtn1 = [
    "pastas",
    "PLATS DU JOUR",
    "CRÊPE PANÉE",
    "SANDWICHS",
    "CHAKLOUB",
    "LES SALADES",
    "HEALTHY FOOD",
    "box",
    "menu kids",
  ];

  const menuBtn2 = [
    "PETIT DEJEUNER FORMULE SIMPLE",
    "PETIT DEJEUNER FORMULE COMPOSÉE",
    "CAFÉ",
    "CHICHA",
    "THÉ",
    "CAFÉ GOURMET",
    "Boissons froides",
    "JUS FRAIS",
    "COCKTAILS",
    "SMOOTHIES",
    "MILKSHAKE",
    "LES GAUFRES",
    "LES PANCAKES",
    "LES CRÊPES SUCRÉES",
    "LES CRÊPES SALÉES",
    "LES OMELETTES",
    "LES PANINIS",
    "LES PLATS DU JOUR",
    "PASTAS",
    "PATISSERIE ET DESSERT",
    "LES PIZZAS",
    "LES SALADES",
    "LES SANDWICHS",
  ];

  useEffect(() => {
    // Update selectedCategory when data changes
    if (data === 'data1') {
      setSelectedCategory("PLATS DU JOUR");
      setMenuButtons(menuBtn1);
    } else if (data === 'data2') {
      setSelectedCategory("PETIT DEJEUNER FORMULE SIMPLE");
      setMenuButtons(menuBtn2);
    }
  }, [data]); // Run this effect whenever `data` changes

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  const handleImageClick = (type) => {
    setShowMenu(true);
    setData(type);
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="menu">
        <h1>MENU</h1>
        <p>
          Explorez notre carte et savourez nos plats{" "}
          <RestaurantIcon fontSize="small" />
        </p>
        <ScrollToTop />
        
        {!showMenu && (
          <div className="menuDivChoosen">
            <div>
            <img 
              src={mall} 
              alt="mascotte_mall" 
              className="menuPicChoosen" 
              onClick={() => handleImageClick("data1")} // Pass "data1"
            />
            <span>mascotte mall of sfax</span>
            </div>
            <div>
            <img 
              src={bouzayen} 
              alt="bouzayen" 
              className="menuPicChoosen" 
              onClick={() => handleImageClick("data2")} // Pass "data2"
            />
              <span>mascotte route Caeid mhamed</span>
              </div>
          </div>
        )}

        {showMenu && (
          <>
            <div className="btnMenu">
              {menuButtons.map((btn, index) => (
                <Button
                  key={index}
                  variant="contained"
                  className={selectedCategory === btn ? "btn active" : "btn"}
                  sx={{ marginRight: 1 }}
                  onClick={() => handleCategoryClick(btn)}
                >
                  {btn}
                </Button>
              ))}
            </div>
            <div className="menuContain">
              <div>
                <MenuItem famille={selectedCategory} dataType={data} /> 
              </div>
            </div>
          </>
        )}

        <Footer />
      </div>
    </ThemeProvider>
  );
}
